import { render, staticRenderFns } from "./CardTeacherNameOnly.vue?vue&type=template&id=450fda76&scoped=true&"
import script from "./CardTeacherNameOnly.vue?vue&type=script&lang=js&"
export * from "./CardTeacherNameOnly.vue?vue&type=script&lang=js&"
import style0 from "./CardTeacherNameOnly.vue?vue&type=style&index=0&id=450fda76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450fda76",
  null
  
)

export default component.exports